// extracted by mini-css-extract-plugin
export default {"font-renta":"FormContainer_font-renta__MaWfD","formContainer":"FormContainer_formContainer__tL54i"};